import { render, staticRenderFns } from "./ExpenseConfigDetailGeneralInfoContainer.vue?vue&type=template&id=415615c5&"
import script from "./ExpenseConfigDetailGeneralInfoContainer.vue?vue&type=script&lang=js&"
export * from "./ExpenseConfigDetailGeneralInfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports